import React from 'react';

// Components
import * as S from './Styled';

const Blank = ({ children, ...rest }) => (
  <S.Blank {...rest}>{children}</S.Blank>
);

export default Blank;
